export enum TenantType {
  Carrier = 'carrier',
  Terminal = 'terminal',
  Exchange = 'exchange',
  IA = 'independent_agent',
  Template = 'template',
  Emperor = 'emperor',
}
